<template>
  <div>
    <gat-tab :items="tabs" :show-in-toolbar="true" />
    <!-- <record-presenter :value="webAccessGroup" />     -->
    <keep-alive>
      <router-view
        v-if="!loadingPortCall"
        :callId="callId"
        location="portcall"
        :parentId="callId"
        :accessGroup="webAccessGroup"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { useToolbarStore } from '@/store/toolbarStore';
import { useHelperStore } from '@/store/helperStore';
// eslint-disable-next-line import/no-cycle
import { getPortcallDetails } from '@/services/api/api-calls/getPortcallDetails';
import { getLastPortCalls } from '@/services/api/api-calls/getLastPortCalls';
import { getHotlist } from '@/services/api/api-calls/getHotlist';
import { getSofTitles } from '@/services/api/api-calls/getSofTitles';
import { useApplicationStore } from '@/store/applicationStore';
import { usePortcallStore } from '@/store/portcallStore';
import { getApplicableVesselName } from '@/services/api/api-calls/getApplicableVesselName';

export default {
  name: 'PortCall',
  props: ['callId'],
  components: {},
  setup() {
    const toolbarStore = useToolbarStore();
    const applicationStore = useApplicationStore();
    const portcallStore = usePortcallStore();
    const helperStore = useHelperStore();
    return {
      helperStore,
      toolbarStore,
      applicationStore,
      portcallStore,
    };
  },
  data() {
    return {
      loadingPortCall: true,
    };
  },

  computed: {
    selectedAgency() {
      return this.applicationStore.agencyIdSelected;
    },
    callDetails() {
      return this.portcallStore.callDetails;
    },
    traversableListItems() {
      return this.applicationStore.whiteboard.whiteBoardData;
    },
    tabHasSqlScripts() {
      return this.helperStore.tabHasSqlScripts;
    },
    tabs() {
      // tabHasData, set noTabData property if you want the no-data icon to work.
      const callCategoryLimit = this.callDetails.callCategoryLimitation;
      let caption = '';
      let sortOrderCaption = '';
      const result = [];
      if (!this.applicationStore.isCRM) {
        sortOrderCaption = 'Details';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Call');
        result.push({ sortOrderCaption, caption, routeName: 'callDetails' });
      }

      if (
        this.hasTabRight('TAB_GOODS') &&
        callCategoryLimit &&
        !callCategoryLimit.Cargo &&
        this.applicationStore.userRight('CA.ACCESS')
      ) {
        sortOrderCaption = 'Cargo';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Cargo');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'cargoList',
          routeParams: { callId: this.callId },
          noTabData: 'GOODS',
        });
      }
      if (this.hasTabRight('TAB_CHECKLIST') && this.applicationStore.userRight('CH.ACCESS')) {
        sortOrderCaption = 'Checklist';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Chk');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'checkList',
          routeParams: { callId: this.callId },
          noTabData: 'CHECKLIST',
        });
      }

      if (this.hasTabRight('TAB_HOTLIST') && this.applicationStore.userRight('H.ACCESS')) {
        sortOrderCaption = 'Clients';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Clnt');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'hotlist',
          routeParams: { callId: this.callId },
          noTabData: 'HOTLIST',
        });
      }

      if (
        this.hasTabRight('TAB_CREW_CHANGE_MODULE') &&
        !this.applicationStore.isCRM &&
        this.applicationStore.globalSettings.SGL_CREW_CHANGE_2021 === 1 &&
        (this.applicationStore.userRight('CRCH.ACCESS') ||
          this.applicationStore.userRight('CRCH.ACCESS_OWN_TASK') ||
          this.applicationStore.userRight('CRCH.ACCESS_ALL_PERSONS'))
      ) {
        sortOrderCaption = 'Crew Change';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Crew');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'crewChange',
          routeParams: { callId: this.callId },
          noTabData: 'CREWCHANGE',
        }); // noTabData:this.tabHasData("CREWCHANGE")
      }

      if (this.hasTabRight('TAB_DOCUMENTS') && this.applicationStore.userRight('DOC.ACCESS')) {
        sortOrderCaption = 'Documents';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Doc');
        result.push({ sortOrderCaption, caption, routeName: 'callDocs', noTabData: 'DOCUMENT' });
      }

      if (
        this.hasTabRight('TAB_EXPENSES') &&
        this.applicationStore.userRight('EX.ACCESS') /* this.webAccessGroup.WAG_EXPENSES > 0 */
      ) {
        sortOrderCaption = 'Expenses';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Exp');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'callExpenses',
          routeParams: { callId: this.callId },
          noTabData: 'EXPENSE',
        });
      }

      if (
        this.hasTabRight('TAB_SERVICES') &&
        !this.applicationStore.isCRM &&
        this.applicationStore.userRight('SER.ACCESS') /* this.webAccessGroup.WAG_SERVICES > 0 */
      ) {
        sortOrderCaption = 'Services';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Serv');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'callServices',
          routeParams: { callId: this.callId },
          noTabData: 'SERVICES',
        });
      }

      if (
        this.hasTabRight('TAB_SOF') &&
        !this.applicationStore.isCRM &&
        callCategoryLimit &&
        !callCategoryLimit.SOF &&
        this.applicationStore.userRight('SOF.ACCESS') /* this.webAccessGroup.WAG_SOF > 0 */
      ) {
        sortOrderCaption = 'SOF';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'sof');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'callSof',
          routeParams: { callId: this.callId },
          noTabData: 'SOF',
        });
      }

      if (
        this.hasTabRight('TAB_VISITORLIST') &&
        !this.applicationStore.isCRM &&
        this.applicationStore.userRight('VI.ACCESS')
      ) {
        sortOrderCaption = 'Visitors';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Vstr');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'visitorList',
          routeParams: { callId: this.callId },
          noTabData: 'VISITOR',
        });
      }

      if (
        this.hasTabRight('TAB_ROUTE') &&
        !this.applicationStore.isCRM &&
        this.applicationStore.userRight('RO.ACCESS')
      ) {
        sortOrderCaption = 'Voyage';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Voy');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'voyageList',
          routeParams: { callId: this.callId },
          noTabData: 'ROUTE',
        });
      }

      if (
        !this.applicationStore.isCRM &&
        this.applicationStore.userRight('AT.WEB_ACCESS') &&
        this.applicationStore.userRight('AT.ACCESS')
      ) {
        sortOrderCaption = 'Attendance';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Att');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'portcallAttendance',
          routeParams: { callId: this.callId },
          noTabData: 'ATTENDANCE',
        });
      }

      if (
        this.hasTabRight('TAB_PROSPECTS') &&
        this.applicationStore.user.internal &&
        this.applicationStore.userRight('PRO.ACCESS')
      ) {
        sortOrderCaption = 'Prospects';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Prosp');
        result.push({
          sortOrderCaption,
          caption,
          routeName: 'prospectsList',
          routeParams: { callId: this.callId },
          noTabData: 'PROSPECTS',
        });
      }

      if (
        this.hasTabRight('TAB_DASHBOARD') &&
        this.applicationStore.userRight('DAS.ACCESS') &&
        this.applicationStore.user.internal &&
        this.tabHasSqlScripts.PORTCALL > 0
      ) {
        sortOrderCaption = 'Dashboard';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Dash');
        result.push({ sortOrderCaption, caption, routeName: 'portcallDashboard', routeParams: {} });
      }
      if (this.hasTabRight('TAB_EMAIL') && this.applicationStore.userRight('EM.ACCESS')) {
        sortOrderCaption = 'E-mail';
        caption = this.shortenCaptionOnMobileTo('Email', 'Mail');
        result.push({ sortOrderCaption, caption, routeName: 'portcallEmailList', noTabData: 'MAIL_SENT' });
      }

      if (this.hasTabRight('TAB_PROFORMA') && this.applicationStore.userRight('PR2.ACCESS')) {
        sortOrderCaption = 'Proforma';
        caption = this.shortenCaptionOnMobileTo(sortOrderCaption, 'Pro');
        result.push({ sortOrderCaption, caption, routeName: 'proformaList', noTabData: 'PROFORMA' });
      }

      // Sort and arrange the sab sequence to be same as Classic
      result.forEach((tab) => {
        const order = this.helperStore.tabSequence.find((seq) => tab.sortOrderCaption === seq.FSE_FIELDCAPTION);
        if (order != undefined) {
          // eslint-disable-next-line no-param-reassign
          tab.tabOrder = order.FSE_SORTORDER;
        } else {
          // eslint-disable-next-line no-param-reassign
          tab.tabOrder = tab.routeName != 'callDetails' ? 999 : 0;
        }
      });
      result.sort((a, b) => parseInt(a.tabOrder, 10) - parseInt(b.tabOrder, 10));

      return result;
    },
    webAccessGroup() {
      let result = this.helperStore.webAccessGroups.find((item) => item.WAG_NAME == this.callDetails.webAccessGroup);
      if (!result) {
        result = {};
      }
      return result;
    },
  },

  created() {
    window.messageBus.$on('toolbar_prev_clicked:portcall', () => {
      if (this.applicationStore.whiteboard.whiteBoardData) {
        let idx = this.applicationStore.whiteboard.whiteBoardData.findIndex((item) => item.ID == this.callId);
        if (idx >= 0) {
          idx -= 1;
          if (idx < 0) {
            idx = this.applicationStore.whiteboard.whiteBoardData.length - 1;
          }
          const newCallId = this.applicationStore.whiteboard.whiteBoardData[idx].ID;
          this.$router.push({ name: this.$route.name, params: { callId: newCallId } });
        }
      }
    });
    window.messageBus.$on('toolbar_next_clicked:portcall', () => {
      if (this.applicationStore.whiteboard.whiteBoardData) {
        let idx = this.applicationStore.whiteboard.whiteBoardData.findIndex((item) => item.ID == this.callId);
        if (idx >= 0) {
          idx += 1;
          if (idx >= this.applicationStore.whiteboard.whiteBoardData.length) {
            idx = 0;
          }
          const newCallId = this.applicationStore.whiteboard.whiteBoardData[idx].ID;
          this.$router.push({ name: this.$route.name, params: { callId: newCallId } });
        }
      }
    });
  },

  activated() {
    if (this.callDetails.vessel) {
      getApplicableVesselName(this.callDetails.vessel.NAME, this.callDetails.vessel.ID, this.callDetails.ID).then(
        (vesselName) => {
          this.toolbarStore.setToolbarTitle(`${vesselName} (${this.callDetails.PORTCALL_NUMBER})`);
        }
      );
    }
    if (this.traversableListItems.length != 0) {
      this.applicationStore.setTraversableList(this.traversableListItems);
      this.applicationStore.setTraversableListCounter(true);
      this.toolbarStore.setToolbarNavBtns({ name: 'portcall', show: true });
    } else if (this.applicationStore.debugMode) {
      console.log('No whiteboard data.');
    }
  },

  deactivated() {
    this.toolbarStore.setToolbarTitle('');
    this.toolbarStore.setToolbarNavBtns({ name: '', show: false });
    this.applicationStore.setTraversableList([]);
    this.applicationStore.setTraversableListCounter(false);
  },

  watch: {
    callDetails(callData) {
      if (callData.vessel) {
        getApplicableVesselName(callData.vessel.NAME, callData.vessel.ID, callData.ID).then((vesselName) => {
          this.toolbarStore.setToolbarTitle(`${vesselName} (${callData.PORTCALL_NUMBER})`);
        });
      }
      const idx = this.traversableListItems.findIndex((item) => item.ID == this.callDetails.ID);
      this.applicationStore.setTraversableListIndex(idx);
    },
    callId: {
      handler(id) {
        if (this.callDetails.ID !== id && id) {
          this.portcallStore.clearCall();
          this.loadPortcallDetails(id);
        }
      },
      immediate: true,
    },
  },

  methods: {
    hasTabRight(tabRight) {
      tabRight.trim();
      let result = 0;
      const portcallAgency = this.callDetails.SETUP_ID; // Agency to which the current portcall belongs.
      if (portcallAgency) {
        const idx = this.applicationStore.agencySettings.findIndex((item) => item.ID == portcallAgency); // Find agencySettings for portcallAgency
        if (idx >= 0) {
          const agency = this.applicationStore.agencySettings[idx]; // Store all the agency settings.
          result = agency[tabRight]; // Check the agency setting for the given argument.
        }
      }
      return result == 1;
    },
    loadPortcallDetails(callId) {
      if (callId) {
        this.loadingPortCall = true;
        if (this.portcallStore.lastCallsUsed.length <= 0) {
          // prevent last used portcalls from being overwritten on application load.
          getLastPortCalls().then(() => {
            getPortcallDetails(callId).then(() => {
              this.loadingPortCall = false;
            });
          });
        } else {
          getPortcallDetails(callId).then(() => {
            this.loadingPortCall = false;
          });
        }
        getHotlist(callId);
        getSofTitles(callId);
      }
    },

    shortenCaptionOnMobileTo(orgValue, shortValue) {
      if (this.$vuetify.breakpoint.xsOnly) {
        return shortValue;
      }
      return orgValue;
    },
  },
};
</script>

<style scoped></style>
